import React, { Component } from 'react'
import { PhoneInput } from 'react-international-phone'
import { validateEmail } from '../../utils/helpers'

class FormLead extends Component {
  constructor(props) {
    super(props)

    const initialState = {
      phone: '',
      gender: '',
      country: 'UNITED STATES',
      birth: '',
      errors: {},
      showSuccessMessage: false,
      showErrorMessage: false
    }

    // Create refs dynamically for phone fields
    this.phoneRefs = {}
    props.config.blocks.forEach(block => {
      if (block.type === 'phone') {
        this.phoneRefs[block.id] = React.createRef()
      }
    })

    this.state = initialState
    this.formRef = React.createRef()
  }

  componentDidMount() {
    this.linkPhoneInputs()
    // Check URL parameters after page refresh
    const urlParams = new URLSearchParams(window.location.search)
    if (urlParams.get('formsubmit') === 'success') {
      this.setState({ showSuccessMessage: true })
    } else if (urlParams.get('formsubmit') === 'error') {
      this.setState({ showErrorMessage: true })
    }
  }

  closeMessage = () => {
    this.setState({
      showSuccessMessage: false,
      showErrorMessage: false
    })
    window.history.replaceState({}, '', window.location.pathname)
  }

  componentDidUpdate() {
    this.linkPhoneInputs()
  }

  linkPhoneInputs = () => {
    Object.entries(this.phoneRefs).forEach(([blockId, ref]) => {
      if (ref.current) {
        ref.current.setAttribute('id', `phone-input-${blockId}`)
      }
    })
  }

  getErrorMessage = (type) => {
    return window.pageStrings?.leadForm?.errors?.[type] || '';
  }

  // Check if phone has actual digits beyond country code
  isPhoneEmpty = (phoneValue) => {
    if (!phoneValue) return true
    // Remove all non-digit characters
    const digitsOnly = phoneValue.replace(/\D/g, '')
    // Consider empty if 3 or fewer digits (typical country code length)
    return digitsOnly.length <= 3
  }

  getFieldValue = (block) => {
    const form = this.formRef.current

    if (block.type === 'phone') {
      // Return empty string if phone only has country code
      return this.isPhoneEmpty(this.state.phone) ? '' : this.state.phone
    } else if (block.type === 'gender') {
      return this.state.gender
    } else if (block.type === 'region') {
      return this.state.country
    } else if (block.type === 'birthday') {
      return this.state.birth
    } else {
      const input = form.querySelector(`[name="field_${block.id}"]`)
      return input?.value?.trim() || ''
    }
  }

  validateForm = async (e) => {
    e.preventDefault()

    const { config } = this.props
    let hasError = false
    const newErrors = {}

    config.blocks.forEach(block => {
      if (!block.required) return

      const value = this.getFieldValue(block)
      console.log(`Block ${block.type} - required: ${block.required}, value: "${value}"`)

      if (value === '') {
        hasError = true
        newErrors[block.id] = this.getErrorMessage('required')
      } else if (block.type === 'email' && !validateEmail(value)) {
        hasError = true
        newErrors[block.id] = this.getErrorMessage('email')
      }
    })

    console.log('Has errors:', hasError, 'Errors:', newErrors)

    if (hasError) {
      this.setState({ errors: newErrors })
    } else {
      // Collect form data
      const formData = {
        firstName: '',
        lastName: '',
        email: '',
        phoneNumber: '',
        birthDate: '',
        country: this.state.country,
        gender: this.state.gender,
        idCampagna: config.api.campaignId || '',
        marketingConsent: true
      }

      // Map blocks to API fields
      config.blocks.forEach(block => {
        const value = this.getFieldValue(block)
        switch(block.type) {
          case 'first_name': formData.firstName = value; break;
          case 'last_name': formData.lastName = value; break;
          case 'email': formData.email = value; break;
          case 'phone': formData.phoneNumber = value; break;
          case 'birthday': formData.birthDate = value; break;
        }
      })

      console.log('Sending to API:', formData)
      console.log('API endpoint:', window.leadFormEndpoint)
      console.log('API key:', window.leadFormApiKey)
      console.log('Campaign ID:', config.api.campaignId)

      try {
        const response = await fetch(window.leadFormEndpoint, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'x-api-key': `${window.leadFormApiKey}`
          },
          body: JSON.stringify({
            event: {
              source: "Shopify",
              channel: "Shopify",
              name: "Lead.Create"
            },
            body: formData
          })
        })

        const result = await response.json()
        console.log('API Response:', result)

        if (response.ok) {
          console.log('Success! Redirecting...')
          // Redirect to refresh page with success message
          window.location.href = `${window.location.pathname}?formsubmit=success`
        } else {
          console.error('API Error:', result)
          // Redirect to refresh page with error message
          window.location.href = `${window.location.pathname}?formsubmit=error`
        }
      } catch (error) {
        console.error('Network Error:', error)
        // Redirect to refresh page with error message
        window.location.href = `${window.location.pathname}?formsubmit=error`
      }
    }
  }

  clearError = (blockId) => {
    this.setState(prevState => {
      const newErrors = { ...prevState.errors }
      delete newErrors[blockId]
      return { errors: newErrors }
    })
  }

  renderField = (block) => {
    const hasError = !!this.state.errors[block.id]
    const errorClass = hasError ? 'input-error' : ''

    switch (block.type) {
      case 'first_name':
      case 'last_name':
      case 'email':
        const placeholderMap = {
          first_name: window.pageStrings.mtm?.firstName,
          last_name: window.pageStrings.mtm?.lastName,
          email: window.pageStrings.mtm?.email
        }
        return (
          <div className={`input-wrap input-wrap--line ${errorClass}`} key={block.id}>
            <input
              type={block.type === 'email' ? 'email' : 'text'}
              name={`field_${block.id}`}
              id={`field-${block.id}`}
              placeholder={placeholderMap[block.type]}
              onChange={() => this.clearError(block.id)}
              required={block.required}
              onFocus={e => e.target.closest('.input-wrap').classList.add('input-wrap__filled')}
              onBlur={e => {
                e.target.closest('.input-wrap').classList.toggle('input-wrap__filled', !!e.target.value)
              }}
            />
            <label htmlFor={`field-${block.id}`}>
              {block.label}{block.required ? ' *' : ''}
            </label>
            {this.state.errors[block.id] && (
              <div className='text-[0.625rem] text-tb-red absolute right-0 -bottom-4'>
                {this.state.errors[block.id]}
              </div>
            )}
          </div>
        )

      case 'phone':
        return (
          <div className="flex flex-col justify-end" key={block.id}>
            <div className={`input-wrap input-wrap--phone relative ${errorClass}`}>
              <PhoneInput
                defaultCountry={Shopify.country.toLowerCase()}
                name={`field_${block.id}`}
                value={this.state.phone}
                onChange={(phone) => {
                  this.setState({ phone })
                  this.clearError(block.id)
                }}
                inputRef={this.phoneRefs[block.id]}
                onFocus={e => e.target.closest('.input-wrap').classList.add('input-wrap__filled')}
                onBlur={e => {
                  e.target.closest('.input-wrap').classList.toggle('input-wrap__filled', !!e.target?.value)
                }}
              />
              <label htmlFor={`phone-input-${block.id}`}>
                {block.label}{block.required ? ' *' : ''}
              </label>
              {this.state.errors[block.id] && (
                <div className='text-[0.625rem] text-tb-red absolute right-0 -bottom-4'>
                  {this.state.errors[block.id]}
                </div>
              )}
            </div>
          </div>
        )

      case 'gender':
        return (
          <div className='select-wrap mt-3' key={block.id}>
            <label htmlFor={`field-${block.id}`}>
              {window.accountStrings.personalInfo.form.gender}{block.required ? ' *' : ''}
            </label>
            <select 
              id={`field-${block.id}`}
              name={`field_${block.id}`}
              value={this.state.gender} 
              onChange={e => {
                this.setState({ gender: e.target.value })
                this.clearError(block.id)
              }}
              className="!px-0 !border-t-0 !border-x-0 !appearance-auto !bg-none focus:outline outline-offset-2"
            >
              <option value=''></option>
              <option value='female'>{window.accountStrings.personalInfo.form.female}</option>
              <option value='male'>{window.accountStrings.personalInfo.form.male}</option>
            </select>
            {this.state.errors[block.id] && (
              <div className='text-[0.625rem] text-tb-red absolute right-0 -bottom-4'>
                {this.state.errors[block.id]}
              </div>
            )}
          </div>
        )

      case 'region':
        return (
          <div className='select-wrap mt-3' key={block.id}>
            <label htmlFor={`field-${block.id}`}>
              {block.label}{block.required ? ' *' : ''}
            </label>
            <select
              id={`field-${block.id}`}
              name={`field_${block.id}`}
              value={this.state.country}
              onChange={e => {
                this.setState({ country: e.target.value })
                this.clearError(block.id)
              }}
              className="!px-0 !border-t-0 !border-x-0 !appearance-auto !bg-none focus:outline outline-offset-2"
            >
              {this.props.config.countries.map(country => (
                <option key={country} value={country}>{country}</option>
              ))}
            </select>
            {this.state.errors[block.id] && (
              <div className='text-[0.625rem] text-tb-red absolute right-0 -bottom-4'>
                {this.state.errors[block.id]}
              </div>
            )}
          </div>
        )

      case 'birthday':
        return (
          <div className={`input-wrap ${errorClass}`} key={block.id}>
            <input
              type="date"
              name={`field_${block.id}`}
              id={`field-${block.id}`}
              value={this.state.birth}
              max={new Date(new Date().setFullYear(new Date().getFullYear() - 16)).toISOString().split('T')[0]}
              onChange={e => {
                this.setState({ birth: e.target.value })
                this.clearError(block.id)
              }}
              onFocus={e => e.target.closest('.input-wrap').classList.add('input-wrap__filled')}
              onBlur={e => {
                e.target.closest('.input-wrap').classList.toggle('input-wrap__filled', !!e.target?.value)
              }}
            />
            <label htmlFor={`field-${block.id}`}>
              {block.label}{block.required ? ' *' : ''}
            </label>
            {this.state.errors[block.id] && (
              <div className='text-[0.625rem] text-tb-red absolute right-0 -bottom-4'>
                {this.state.errors[block.id]}
              </div>
            )}
          </div>
        )

      default:
        return null
    }
  }

  // Organize fields into rows based on their type
  organizeFields = () => {
    const { blocks } = this.props.config
    const rows = []
    let currentRow = []

    blocks.forEach((block, index) => {
      currentRow.push(block)
      if (currentRow.length === 2 || index === blocks.length - 1) {
        rows.push([...currentRow])
        currentRow = []
      }
    })
    return rows
  }

  render() {
    const { config } = this.props
    const rows = this.organizeFields()

    return (
      <>
        {/* Success/Error message */}
        {(this.state.showSuccessMessage || this.state.showErrorMessage) && (
          <div className="fixed inset-0 flex items-center justify-center z-50 show-message">
            {/* Message Card */}
            <div className="relative bg-white shadow-2xl p-8 max-w-md mx-4 border z-10 show-message-content">
              {this.state.showSuccessMessage && (
                <p className="text-center">{config.strings.success_message}</p>
              )}
              {this.state.showErrorMessage && (
                <p className="text-center text-tb-red">{window.pageStrings.leadForm.errors.form_error}</p>
              )}

              {/* close button */}
              <button
                  className="absolute mt-2 top-1 right-3 text-black cursor-pointer z-10 w-2.5 h-2.5"
                  onClick={this.closeMessage}
                  aria-label="close"
                >
                  <svg className="icon icon-close w-2.5 h-2.5" viewBox="0 0 22.44 22.44" fill="none" stroke="currentColor">
                    <line x1="1" y1="21.44" x2="21.44" y2="1" />
                    <line x1="1" y1="1" x2="21.44" y2="21.44" />
                  </svg>
              </button>
            </div>
          </div>
        )}

        <form
          className='grid grid-cols-1 gap-6'
          noValidate
          onSubmit={this.validateForm}
          ref={this.formRef}
        >
          {/* Hidden fields */}
          {config.api && config.api.campaignId && (
            <input type="hidden" name="campaignId" value={config.api.campaignId} />
          )}

          {/* Form title */}
          {config.strings.form_title && (
            <h2 className="checkbox-text mb-2">{config.strings.form_title}</h2>
          )}

          {rows.map((row, rowIndex) => (
            <div key={rowIndex} className={'grid lg:grid-cols-2 gap-5'}>
              {row.map(block => this.renderField(block))}
            </div>
          ))}

          <div
            className="text-[0.625rem] contact-form-privacy"
            dangerouslySetInnerHTML={{ __html: window.pageStrings.leadForm.marketingConsent }}
          />

          <div>
            <input
              className={`button button--primary !rounded-none !w-full mt-1`}
              type="submit"
              value={config.strings.cta}
            />
          </div>
        </form>
      </>
    )
  }
}

export default FormLead